/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cenorion Tenant Edge API (DEV)
 * Live API Gateway routes, documented from backend contracts/rest.
 * OpenAPI spec version: live
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  IdentityInviteUserRequest,
  IdentityInviteUserResponse,
  IdentityRolesOverviewResponse,
  IdentityRolesResponse,
  IdentitySsoSettings,
  IdentityTotpResetRequest,
  IdentityUserActionResponse,
  IdentityUserResponse,
  IdentityUsersResponse,
  ListUsersParams,
  ProblemDetails
} from '../../models';

import { apiMutator } from '../../../http/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * The caller's tenant's role catalogue — value, label, domain and `assignable` — so role pickers and the Users list filter stop hardcoding a list.
 * @summary List the roles a user of the caller's tenant can hold
 */
export const listRoles = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<IdentityRolesResponse>(
      {url: `/v1/identity/roles`, method: 'GET', signal
    },
      options);
    }




export const getListRolesQueryKey = () => {
    return [
    `/v1/identity/roles`
    ] as const;
    }


export const getListRolesQueryOptions = <TData = Awaited<ReturnType<typeof listRoles>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRolesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRoles>>> = ({ signal }) => listRoles(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRolesQueryResult = NonNullable<Awaited<ReturnType<typeof listRoles>>>
export type ListRolesQueryError = ProblemDetails


export function useListRoles<TData = Awaited<ReturnType<typeof listRoles>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRoles>>,
          TError,
          Awaited<ReturnType<typeof listRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRoles<TData = Awaited<ReturnType<typeof listRoles>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRoles>>,
          TError,
          Awaited<ReturnType<typeof listRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRoles<TData = Awaited<ReturnType<typeof listRoles>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the roles a user of the caller's tenant can hold
 */

export function useListRoles<TData = Awaited<ReturnType<typeof listRoles>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRolesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Every field the store holds for each tenant role — permissions, scope, copy — plus who in the caller's tenant holds it.
 * @summary The Roles & permissions tab in one read
 */
export const getRolesOverview = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<IdentityRolesOverviewResponse>(
      {url: `/v1/identity/roles/overview`, method: 'GET', signal
    },
      options);
    }




export const getGetRolesOverviewQueryKey = () => {
    return [
    `/v1/identity/roles/overview`
    ] as const;
    }


export const getGetRolesOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getRolesOverview>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRolesOverview>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRolesOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRolesOverview>>> = ({ signal }) => getRolesOverview(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRolesOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRolesOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getRolesOverview>>>
export type GetRolesOverviewQueryError = ProblemDetails


export function useGetRolesOverview<TData = Awaited<ReturnType<typeof getRolesOverview>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRolesOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRolesOverview>>,
          TError,
          Awaited<ReturnType<typeof getRolesOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRolesOverview<TData = Awaited<ReturnType<typeof getRolesOverview>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRolesOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRolesOverview>>,
          TError,
          Awaited<ReturnType<typeof getRolesOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRolesOverview<TData = Awaited<ReturnType<typeof getRolesOverview>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRolesOverview>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The Roles & permissions tab in one read
 */

export function useGetRolesOverview<TData = Awaited<ReturnType<typeof getRolesOverview>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRolesOverview>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRolesOverviewQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The current value for the tenant in the verified claim.
 * @summary Read the caller's tenant SSO-only switch
 */
export const getTenantSso = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<IdentitySsoSettings>(
      {url: `/v1/identity/sso`, method: 'GET', signal
    },
      options);
    }




export const getGetTenantSsoQueryKey = () => {
    return [
    `/v1/identity/sso`
    ] as const;
    }


export const getGetTenantSsoQueryOptions = <TData = Awaited<ReturnType<typeof getTenantSso>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantSso>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantSsoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantSso>>> = ({ signal }) => getTenantSso(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenantSso>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantSsoQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantSso>>>
export type GetTenantSsoQueryError = ProblemDetails


export function useGetTenantSso<TData = Awaited<ReturnType<typeof getTenantSso>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantSso>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantSso>>,
          TError,
          Awaited<ReturnType<typeof getTenantSso>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantSso<TData = Awaited<ReturnType<typeof getTenantSso>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantSso>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantSso>>,
          TError,
          Awaited<ReturnType<typeof getTenantSso>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantSso<TData = Awaited<ReturnType<typeof getTenantSso>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantSso>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read the caller's tenant SSO-only switch
 */

export function useGetTenantSso<TData = Awaited<ReturnType<typeof getTenantSso>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantSso>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantSsoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Replaces the setting for the tenant in the verified claim.
 * @summary Set the caller's tenant SSO-only switch
 */
export const putTenantSso = (
    identitySsoSettings: IdentitySsoSettings,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<IdentitySsoSettings>(
      {url: `/v1/identity/sso`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: identitySsoSettings, signal
    },
      options);
    }




export const getPutTenantSsoMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTenantSso>>, TError,{data: IdentitySsoSettings}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof putTenantSso>>, TError,{data: IdentitySsoSettings}, TContext> => {

const mutationKey = ['putTenantSso'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTenantSso>>, {data: IdentitySsoSettings}> = (props) => {
          const {data} = props ?? {};

          return  putTenantSso(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTenantSsoMutationResult = NonNullable<Awaited<ReturnType<typeof putTenantSso>>>
    export type PutTenantSsoMutationBody = IdentitySsoSettings
    export type PutTenantSsoMutationError = ProblemDetails

    /**
 * @summary Set the caller's tenant SSO-only switch
 */
export const usePutTenantSso = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTenantSso>>, TError,{data: IdentitySsoSettings}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTenantSso>>,
        TError,
        {data: IdentitySsoSettings},
        TContext
      > => {
      return useMutation(getPutTenantSsoMutationOptions(options), queryClient);
    }
    /**
 * Lost-phone recovery.
 * @summary Clear a user's TOTP registration so they re-enrol on their next sign-in
 */
export const resetUserTotp = (
    identityTotpResetRequest: IdentityTotpResetRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/v1/identity/totp-reset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identityTotpResetRequest, signal
    },
      options);
    }




export const getResetUserTotpMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUserTotp>>, TError,{data: IdentityTotpResetRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof resetUserTotp>>, TError,{data: IdentityTotpResetRequest}, TContext> => {

const mutationKey = ['resetUserTotp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetUserTotp>>, {data: IdentityTotpResetRequest}> = (props) => {
          const {data} = props ?? {};

          return  resetUserTotp(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetUserTotpMutationResult = NonNullable<Awaited<ReturnType<typeof resetUserTotp>>>
    export type ResetUserTotpMutationBody = IdentityTotpResetRequest
    export type ResetUserTotpMutationError = ProblemDetails

    /**
 * @summary Clear a user's TOTP registration so they re-enrol on their next sign-in
 */
export const useResetUserTotp = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUserTotp>>, TError,{data: IdentityTotpResetRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetUserTotp>>,
        TError,
        {data: IdentityTotpResetRequest},
        TContext
      > => {
      return useMutation(getResetUserTotpMutationOptions(options), queryClient);
    }
    /**
 * One page of the caller's OWN tenant's users, with search, two filters, sorting and page-number pagination.
 * @summary List the caller's tenant's users
 */
export const listUsers = (
    params?: ListUsersParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<IdentityUsersResponse>(
      {url: `/v1/identity/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListUsersQueryKey = (params?: ListUsersParams,) => {
    return [
    `/v1/identity/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = ProblemDetails>(params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = ProblemDetails


export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ProblemDetails>(
 params: undefined |  ListUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ProblemDetails>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ProblemDetails>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the caller's tenant's users
 */

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ProblemDetails>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A Tenant Admin invites one user by email.
 * @summary Invite a user into the caller's tenant
 */
export const inviteUser = (
    identityInviteUserRequest: IdentityInviteUserRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<IdentityInviteUserResponse>(
      {url: `/v1/identity/users/invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identityInviteUserRequest, signal
    },
      options);
    }




export const getInviteUserMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteUser>>, TError,{data: IdentityInviteUserRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteUser>>, TError,{data: IdentityInviteUserRequest}, TContext> => {

const mutationKey = ['inviteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteUser>>, {data: IdentityInviteUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  inviteUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InviteUserMutationResult = NonNullable<Awaited<ReturnType<typeof inviteUser>>>
    export type InviteUserMutationBody = IdentityInviteUserRequest
    export type InviteUserMutationError = ProblemDetails

    /**
 * @summary Invite a user into the caller's tenant
 */
export const useInviteUser = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteUser>>, TError,{data: IdentityInviteUserRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inviteUser>>,
        TError,
        {data: IdentityInviteUserRequest},
        TContext
      > => {
      return useMutation(getInviteUserMutationOptions(options), queryClient);
    }
    /**
 * The profile behind a row of the Users list, addressed by the pool `sub` and never by email — an address in a path lands in API Gateway and CloudFront access logs, and it is PII.
 * @summary One user of the caller's tenant
 */
export const getUser = (
    id: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<IdentityUserResponse>(
      {url: `/v1/identity/users/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetUserQueryKey = (id: string,) => {
    return [
    `/v1/identity/users/${id}`
    ] as const;
    }


export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserQueryError = ProblemDetails


export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One user of the caller's tenant
 */

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Hard-deletes a user of the caller's tenant, with no undo: the pool user first (which ends their refresh tokens), then the row and all role index entries in one write.
 * @summary Delete a user of the caller's tenant
 */
export const deleteUser = (
    id: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/v1/identity/users/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteUserMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>

    export type DeleteUserMutationError = ProblemDetails

    /**
 * @summary Delete a user of the caller's tenant
 */
export const useDeleteUser = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUser>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteUserMutationOptions(options), queryClient);
    }
    /**
 * Soft-deletes a user of the caller's tenant: the row moves to `DEACTIVATED` with `deactivated_at`, and its gate to `BLOCKED`, in one write.
 * @summary Deactivate a user of the caller's tenant
 */
export const deactivateUser = (
    id: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<IdentityUserActionResponse>(
      {url: `/v1/identity/users/${id}/deactivate`, method: 'PATCH', signal
    },
      options);
    }




export const getDeactivateUserMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deactivateUser>>, TError,{id: string}, TContext> => {

const mutationKey = ['deactivateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateUser>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deactivateUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeactivateUserMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateUser>>>

    export type DeactivateUserMutationError = ProblemDetails

    /**
 * @summary Deactivate a user of the caller's tenant
 */
export const useDeactivateUser = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivateUser>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeactivateUserMutationOptions(options), queryClient);
    }
    /**
 * Reopens a deactivated user of the caller's tenant: the pool user is enabled FIRST, then the row moves back with its gate `ALLOWED` and `reactivated_at` set; `deactivated_at` is kept.
 * @summary Reactivate a deactivated user of the caller's tenant
 */
export const reactivateUser = (
    id: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<IdentityUserActionResponse>(
      {url: `/v1/identity/users/${id}/reactivate`, method: 'PATCH', signal
    },
      options);
    }




export const getReactivateUserMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivateUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof reactivateUser>>, TError,{id: string}, TContext> => {

const mutationKey = ['reactivateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reactivateUser>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  reactivateUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReactivateUserMutationResult = NonNullable<Awaited<ReturnType<typeof reactivateUser>>>

    export type ReactivateUserMutationError = ProblemDetails

    /**
 * @summary Reactivate a deactivated user of the caller's tenant
 */
export const useReactivateUser = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivateUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reactivateUser>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getReactivateUserMutationOptions(options), queryClient);
    }
